import axios from "@/axios-auth";
import { mensagemDeValidacao } from "@/utils/erros-api";
import { isEquipeDourasoft } from "@/utils/venda-online";

export const VENDA_ONLINE_APLICATIVO_ID = 19;

const ROTAS = {
  disponibilidade: "/vendas-online/disponibilidade",
  configuracao: "/vendas-online/configuracao",
  horarios: "/vendas-online/horarios",
  vendas: "/vendas-online",
  previa: "/vendas-online/previa",
  lista: "/vendas-online/lista",
  indicadores: "/vendas-online/indicadores",
  caixa: "/vendas-online/caixa"
};

const parseRespostaErros = (res) => (res.error && res.error.response && res.error.response.data) || {};

const SEM_PAGINAS = { page: 1, pageCount: 1, count: 0, prevPage: false, nextPage: false };

const EMPTY_LISTA = { vendas: [], avisos: [], paging: SEM_PAGINAS };

const state = {
  isVendaOnlineAvailable: false,
  vendaOnlineConfiguracao: null,
  vendaOnlineErros: {},
  isVendaOnlineLoading: false,
  isVendaOnlineSaving: false,
  vendasOnlineLista: { ...EMPTY_LISTA },
  vendasOnlineIndicadores: null,
  isVendasOnlineListaLoading: false,
  vendaOnlineNovaVenda: null
};

const mutations = {
  setVendaOnlineAvailable: (state, valor) => {
    state.isVendaOnlineAvailable = valor === true;
  },
  setVendaOnlineConfiguracao: (state, valor) => {
    state.vendaOnlineConfiguracao = valor;
  },
  setVendaOnlineErros: (state, valor) => {
    state.vendaOnlineErros = valor || {};
  },
  setVendaOnlineLoading: (state, valor) => {
    state.isVendaOnlineLoading = valor;
  },
  setVendaOnlineSaving: (state, valor) => {
    state.isVendaOnlineSaving = valor;
  },
  setVendasOnlineLista: (state, valor) => {
    state.vendasOnlineLista = { ...EMPTY_LISTA, ...(valor || {}), paging: { ...SEM_PAGINAS, ...((valor && valor.paging) || {}) } };
  },
  setVendasOnlineIndicadores: (state, valor) => {
    state.vendasOnlineIndicadores = valor || null;
  },
  setVendasOnlineListaLoading: (state, valor) => {
    state.isVendasOnlineListaLoading = valor;
  },
  setVendaOnlineNovaVenda: (state, valor) => {
    state.vendaOnlineNovaVenda = valor || null;
  }
};

let pedidoLista = 0;

let pedidoIndicadores = 0;

const actions = {
  async fetchVendaOnlineDisponibilidade({ commit }) {
    const res = await axios.get(ROTAS.disponibilidade);
    const disponivel = !res.error && res.data && res.data.data ? res.data.data.disponivel : false;

    commit("setVendaOnlineAvailable", disponivel);
  },

  async fetchVendaOnlineConfiguracao({ commit }) {
    commit("setVendaOnlineLoading", true);
    const res = await axios.get(ROTAS.configuracao);
    commit("setVendaOnlineLoading", false);

    if (res.error) return { ok: false };

    commit("setVendaOnlineConfiguracao", res.data.data);
    commit("setVendaOnlineErros", {});

    return { ok: true };
  },

  async saveVendaOnlineConfiguracao({ commit, dispatch }, opcoes) {
    commit("setVendaOnlineSaving", true);
    const res = await axios.post(ROTAS.configuracao, { opcoes });
    commit("setVendaOnlineSaving", false);

    if (res.error) {
      const data = (res.error.response && res.error.response.data) || {};
      commit("setVendaOnlineErros", data.errors);

      return {
        ok: false,
        mensagem: mensagemDeValidacao(data.errors) || data.message || "Não foi possível salvar a configuração da Venda Online."
      };
    }

    commit("setVendaOnlineConfiguracao", res.data.data);
    commit("setVendaOnlineErros", {});
    dispatch("fetchVendaOnlineDisponibilidade");

    return { ok: true, mensagem: res.data.message };
  },

  async fetchVendaOnlineHorarios() {
    const res = await axios.get(ROTAS.horarios);

    if (res.error) return { ok: false, horarios: [] };

    return { ok: true, horarios: res.data.data, meta: res.data.meta };
  },

  async saveVendaOnlineHorarios(context, horarios) {
    const res = await axios.post(ROTAS.horarios, { horarios });

    if (res.error) {
      const data = parseRespostaErros(res);

      return {
        ok: false,
        mensagem: mensagemDeValidacao(data.errors) || data.message || "Não foi possível salvar os horários de corte."
      };
    }

    return { ok: true, horarios: res.data.data };
  },

  async previewVendaOnline(context, pedido) {
    const res = await axios.post(ROTAS.previa, pedido);

    if (res.error) {
      const data = parseRespostaErros(res);

      return { ok: false, mensagem: data.message || "Não foi possível conferir a venda online." };
    }

    return { ok: true, previa: res.data.data };
  },

  async createVendaOnline(context, pedido) {
    const res = await axios.post(ROTAS.vendas, pedido);

    if (res.error) {
      const data = parseRespostaErros(res);

      return {
        ok: false,
        pendencias: (data.data && data.data.pendencias) || [],
        mensagem: mensagemDeValidacao(data.errors) || data.message || "Não foi possível gerar a venda online."
      };
    }

    return { ok: true, venda: res.data.data, mensagem: res.data.message };
  },

  async fetchVendasOnlineLista({ commit }, filtros) {
    const pedido = ++pedidoLista;
    commit("setVendasOnlineListaLoading", true);
    const res = await axios.get(ROTAS.lista, { params: filtros });
    if (pedido !== pedidoLista) return { ok: true, antiga: true };
    commit("setVendasOnlineListaLoading", false);

    if (res.error) {
      commit("setVendasOnlineLista", null);

      return { ok: false, mensagem: parseRespostaErros(res).message || "Não foi possível carregar as vendas online." };
    }

    commit("setVendasOnlineLista", { ...res.data.data, paging: res.data.paging });

    return { ok: true };
  },

  async fetchVendasOnlineIndicadores({ commit }, filtros) {
    const pedido = ++pedidoIndicadores;
    const res = await axios.get(ROTAS.indicadores, { params: filtros });
    if (pedido !== pedidoIndicadores) return { ok: true, antiga: true };

    if (res.error) {
      commit("setVendasOnlineIndicadores", null);

      return { ok: false, mensagem: parseRespostaErros(res).message || "Não foi possível carregar os indicadores." };
    }

    commit("setVendasOnlineIndicadores", res.data.data);

    return { ok: true };
  },

  async fetchVendaOnline(context, id) {
    const res = await axios.get(`${ROTAS.vendas}/${id}`);

    if (res.error) {
      return { ok: false, mensagem: parseRespostaErros(res).message || "Não foi possível abrir a venda online." };
    }

    return { ok: true, venda: res.data.data };
  },

  async fetchVendasOnlineCaixa(context, movcaixaId) {
    const res = await axios.get(`${ROTAS.caixa}/${movcaixaId}`);

    if (res.error) {
      return {
        ok: false,
        vendas: [],
        paging: null,
        mensagem: parseRespostaErros(res).message || "Não foi possível carregar as vendas online do caixa."
      };
    }

    return { ok: true, vendas: res.data.data, paging: res.data.paging, abertasOcultas: res.data.abertas_ocultas || 0 };
  },

  async cancelVendaOnline(context, { id, motivo }) {
    const res = await axios.post(`${ROTAS.vendas}/${id}/cancelar`, { motivo });

    if (res.error) {
      const data = parseRespostaErros(res);

      return { ok: false, mensagem: mensagemDeValidacao(data.errors) || data.message || "Não foi possível cancelar a venda." };
    }

    const { nova_venda: novaVenda, ...venda } = res.data.data;

    return { ok: true, venda, novaVenda, mensagem: res.data.message };
  },

  async fetchVendaOnlineDestinos(context, id) {
    const res = await axios.get(`${ROTAS.vendas}/${id}/transferir`);

    if (res.error) {
      return { ok: false, destinos: [], mensagem: parseRespostaErros(res).message || "Não foi possível carregar os caixas abertos." };
    }

    return { ok: true, destinos: res.data.data };
  },

  async transferVendasOnline(context, { ids, movcaixaId }) {
    const res = await axios.post(`${ROTAS.vendas}/transferir-em-massa`, { ids, movcaixa_id: movcaixaId });

    if (res.error) {
      const data = parseRespostaErros(res);

      return { ok: false, resultados: [], mensagem: mensagemDeValidacao(data.errors) || data.message || "Não foi possível transferir as vendas." };
    }

    return { ok: true, resultados: res.data.data.resultados, mensagem: res.data.message };
  },

  async cancelVendasOnline(context, { ids, motivo, frase }) {
    const res = await axios.post(`${ROTAS.vendas}/cancelar-em-massa`, { ids, motivo, frase });

    if (res.error) {
      const data = parseRespostaErros(res);

      return { ok: false, mensagem: mensagemDeValidacao(data.errors) || data.message || "Não foi possível cancelar as vendas." };
    }

    return { ok: true, resultados: res.data.data.resultados, mensagem: res.data.message };
  },

  async resolveVendaOnlineConflito(context, { id, nota, decisao, ultimoEventoId }) {
    const res = await axios.post(`${ROTAS.vendas}/${id}/resolver-conflito`, { nota, decisao, ultimo_evento_id: ultimoEventoId });

    if (res.error) {
      const data = parseRespostaErros(res);

      return { ok: false, mensagem: mensagemDeValidacao(data.errors) || data.message || "Não foi possível resolver o conflito." };
    }

    return { ok: true, venda: res.data.data, pendente: Boolean(res.data.data.conflito_pendente), mensagem: res.data.message };
  },

  async resolveVendaOnlineAviso(context, { id, nota }) {
    const res = await axios.post(`${ROTAS.vendas}/avisos/${id}/resolver`, { nota });

    if (res.error) {
      const data = parseRespostaErros(res);

      return { ok: false, mensagem: mensagemDeValidacao(data.errors) || data.message || "Não foi possível resolver o aviso." };
    }

    return { ok: true, mensagem: res.data.message };
  },

  async resendVendaOnlineLink(context, id) {
    const res = await axios.post(`${ROTAS.vendas}/${id}/reenviar`);

    if (res.error) {
      return { ok: false, mensagem: parseRespostaErros(res).message || "Não foi possível reenviar o link." };
    }

    return { ok: true, enfileirado: res.data.data.enfileirado, mensagem: res.data.message };
  }
};

const getters = {
  isVendaOnlineContracted: (state, getters, rootState) => {
    const empresa = rootState.profile && rootState.profile.dataEmpresa;
    const aplicativos = empresa ? empresa.aplicativos : null;

    return Array.isArray(aplicativos) && aplicativos.some((a) => Number(a.id) === VENDA_ONLINE_APLICATIVO_ID);
  },
  hasVendaOnlineListarPermissao: (state, getters, rootState) => {
    const usuario = rootState.profile && rootState.profile.dataUser;
    const acesso = usuario ? usuario.acesso : null;

    return Array.isArray(acesso) && acesso.includes("VendasOnline.index");
  },
  hasVendaOnlineCriarPermissao: (state, getters, rootState) => {
    const usuario = rootState.profile && rootState.profile.dataUser;
    const acesso = usuario ? usuario.acesso : null;

    return Array.isArray(acesso) && acesso.includes("VendasOnline.add");
  },
  hasVendaOnlineEditarPermissao: (state, getters, rootState) => {
    const usuario = rootState.profile && rootState.profile.dataUser;
    const acesso = usuario ? usuario.acesso : null;

    return Array.isArray(acesso) && acesso.includes("VendasOnline.edit");
  },
  isEquipeDourasoft: (state, getters, rootState) => isEquipeDourasoft(rootState.profile && rootState.profile.dataUser),
  isVendaOnlineConfiguravel: (state, getters) => getters.isVendaOnlineContracted && getters.hasVendaOnlineEditarPermissao,
  isVendaOnlineAvailable: (state) => state.isVendaOnlineAvailable,
  vendaOnlineNovaVenda: (state) => state.vendaOnlineNovaVenda,
  vendaOnlineConfiguracao: (state) => state.vendaOnlineConfiguracao,
  vendaOnlineErros: (state) => state.vendaOnlineErros,
  isVendaOnlineLoading: (state) => state.isVendaOnlineLoading,
  isVendaOnlineSaving: (state) => state.isVendaOnlineSaving,
  vendasOnlineLista: (state) => state.vendasOnlineLista,
  vendasOnlineIndicadores: (state) => state.vendasOnlineIndicadores,
  isVendasOnlineListaLoading: (state) => state.isVendasOnlineListaLoading
};

export default {
  state,
  mutations,
  actions,
  getters
};
